// import React, { useState } from "react";
// import "./blogD.css";
// import Footer from "../footer/footer";
// import Header from "../header/header";
// import OwlCarousel from "react-owl-carousel";
// import "owl.carousel/dist/assets/owl.carousel.css";
// import "owl.carousel/dist/assets/owl.theme.default.css";
// import NewHeader from "../NewHeader/NewHeader";
// import { useEffect } from "react";
// import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom.min";
// import {
//   FacebookShareButton,
//   FacebookIcon,
//   TwitterShareButton,
//   LinkedinShareButton,
//   WhatsappShareButton,
//   EmailShareButton,
//   TelegramShareButton,
//   TwitterIcon,
//   LinkedinIcon,
//   WhatsappIcon,
//   EmailIcon,
//   TelegramIcon,
// } from "react-share";
// import {
//   AiOutlineLike,
//   AiTwotoneLike,
//   AiOutlineComment,
//   AiOutlineWechat,
// } from "react-icons/ai";
// import ServiceStore from "../../utils/ServiceStore";

// const BlogD = () => {
//   const location = useLocation();
//   const history = useHistory();
//   const [data, setData] = useState('');
//   const shareUrl = window.location.href;
//   const [isshowcomment, setisshowcomment] = React.useState(false);
//   const [isshowcommentReply, setisshowcommentReply] = React.useState(undefined);
// const [Commentlist, setCommentlist] = React.useState([]);
// const [commentsToShow, setCommentsToShow] = useState(4);
// const insertcommentReply = (id) => setisshowcommentReply(id);
// const [newDate, setNewDate] = React.useState("");
// const [detailsList, setDetailsList] = React.useState({});
// const [isLikeshow, setisLikeshow] = React.useState(true);
// const [iserror, setiserror] = React.useState("");
// const [likewriteblogtopiclist, setlikewriteblogtopiclist] = React.useState();
// const [relatedData, setRelatedData] = useState([]);
// const [LikeList, setLikeList] = React.useState({});
// const [reply, setreply] = React.useState("");
// const [comment, setcomment] = React.useState("");

// React.useEffect(() => {
//   const dataid = history.location.state?.id;
//   const hisData = history.location.state;
//   console.log(dataid,hisData)
//   // getcommentwriteblogtopic();
//   // if (dataid) {
//   //   getLikelist();
//   //   new ServiceStore()
//   //     .GetDataByID("writeblogtopic/", dataid)
//   //     .then((res) => {
//   //       const dates = res.data.updatedAt;
//   //       setNewDate(
//   //         res.data.updatedAt.split("T")[0].split("-").reverse().join("/")
//   //       );
//   //       setDetailsList(res.data);
//   //     });
//   //   // new ServiceStore().GetAllData('likewriteblogtopic/English').then((res) => {
//   //   //   setlikewriteblogtopiclist(res.data)
//   //   // });
//   //   const auth = sessionStorage.getItem("items");
//   //   if (auth) {
//   //     const data = {
//   //       writeblogtopicId: dataid,
//   //       userID: JSON.parse(auth)._id,
//   //     };
//   //     new ServiceStore()
//   //       .GetDataBYFilter("likewriteblogtopic/EnglishListByID", data)
//   //       .then((res) => {
//   //         if (res.response.data.length == 1) {
//   //           setisLikeshow(false);
//   //         }
//   //         setLikeList(res.response.data);
//   //       });
//   //   }
//   // }

//   // new ServiceStore().GetAllData("writeblogtopic/English").then((res) => {
//   //   const array = [];
//   //   res.data.filter((data) => {
//   //     if (data.categoryId === hisData.categoryId) {
//   //       data.createdAt = data.createdAt
//   //         .split("T")[0]
//   //         .split("-")
//   //         .reverse()
//   //         .join("/");
//   //       array.push(data);
//   //     }
//   //   });
//   //   setRelatedData(array);
//   // });
// }, []);
// const date = new Date();
// const day = date.getDate();
// const month = date.getMonth() + 1;
// const year = date.getFullYear();
// const h = date.getHours();
// const m = date.getMinutes();

// const getLikelist = () => {
//   const dataid = history.location.state?.id;
//   new ServiceStore()
//     .GetDataByID("likewriteblogtopic/English/", dataid)
//     .then((res) => {
//       setlikewriteblogtopiclist(res.data ? res.data : 1);
//     });
// };
// const addLike = (index, e) => {
//   setlikewriteblogtopiclist(
//     (likewriteblogtopiclist ? parseInt(likewriteblogtopiclist) : 1) + 1
//   );
//   const auth = sessionStorage.getItem("items");
//   if (auth) {
//     const methods = "likewriteblogtopic/";
//     const data = {
//       language: "english",
//       username: JSON.parse(auth).name,
//       count: 1,
//       writeblogtopicId: detailsList._id,
//       like: 1,
//       status: "IsLike",
//       userID: JSON.parse(auth)._id,
//     };
//     new ServiceStore().InsertData(methods, data).then((res) => {
//       setisLikeshow(false);
//       getLikelist();
//     });
//   } else {
//     setiserror("Please Log in First");
//   }
// };
// const AddComment = (index, e) => {
//   setisshowcomment(true);
// };

// const deleteLike = (index, e) => {
//   const auth = sessionStorage.getItem("items");
//   if (auth) {
//     const methods = "likewriteblogtopic/deletelike";
//     const data = {
//       writeblogtopicId: detailsList._id,
//       userID: JSON.parse(auth)._id,
//     };
//     new ServiceStore().InsertData(methods, data).then((res) => {
//       setisLikeshow(true);
//       getLikelist();
//     });
//   } else {
//     setiserror("Please Log in First");
//   }
// };
// const handleSubmit = (e) => {
//   e.preventDefault();
//   if (comment != undefined) {
//     const auth = JSON.parse(sessionStorage.getItem("items"));
//     const methods = "commentwriteblogtopic/";
//     const data = {
//       likecount: 0,
//       language: "english",
//       username: auth.name,
//       comment: comment,
//       writeblogtopicId: detailsList._id,
//       status: "IsComment",
//       userID: auth._id,
//     };
//     new ServiceStore().InsertData(methods, data).then((res) => {
//       getcommentwriteblogtopic();
//     });
//   }
//   setisshowcomment(false);
// };

// const getcommentwriteblogtopic = () => {
//   const dataid = history.location.state?.id;
//   const auth = JSON.parse(sessionStorage.getItem("items"));
//   const data = { writeblogtopicId: dataid, userID: auth._id };
//   new ServiceStore()
//     .GetDataBYFilter("commentwriteblogtopic/EnglishListByID", data)
//     .then((res) => {
//       console.log(res);
//       res.response.data.filter((data) => {
//         const d = data.createdAt.split("T")[0].split("-").reverse().join("/");
//         const t = data.createdAt
//           .split("T")[1]
//           .split("-")
//           .reverse()
//           .join("/")
//           .split(":");
//         const full = d + " " + t[0].concat(":", t[1]);

//         data.createdAt = full;
//       });
//       setCommentlist(res.response.data);
//     });
// };

// const updatecommentLike = (index, e) => {
//   const auth = JSON.parse(sessionStorage.getItem("items"));
//   if (auth) {
//     const methods = "likecommentwriteblogtopic";
//     const data = {
//       likecount: 1,
//       language: "english",
//       username: auth.name,
//       writeblogtopicId: index.writeblogtopicId,
//       status: "IsLike",
//       userID: auth._id,
//       commentId: index.id,
//     };
//     new ServiceStore().InsertData(methods, data).then((res) => {
//       getcommentwriteblogtopic();
//     });
//   } else {
//     setiserror("Please Log in First");
//   }
// };
// const deletecommentLike = (index, u, e) => {
//   const auth = sessionStorage.getItem("items");
//   const likecount = Number(index.likecount) - 1;
//   if (auth) {
//     const methods = "likecommentwriteblogtopic/";

//     new ServiceStore().DeleteData(methods, u._id).then((res) => {
//       getcommentwriteblogtopic();
//     });
//   } else {
//     setiserror("Please Log in First");
//   }
// };

// const SubmitReply = (item, e) => {
//   e.preventDefault();
//   const auth = JSON.parse(sessionStorage.getItem("items"));
//   if (reply != "") {
//     const methods = "replaycommentwriteblogtopic/";
//     const data = {
//       likecount: 0,
//       language: "english",
//       username: auth.name,
//       reply: reply,
//       writeblogtopicId: item.writeblogtopicId,
//       status: "IsReply",
//       userID: auth._id,
//       commentId: item.id,
//     };
//     new ServiceStore().InsertData(methods, data).then((res) => {
//       getcommentwriteblogtopic();
//       setisshowcommentReply(undefined);
//       // history.push("/English/Forum");
//     });
//   }
// };

// const postTitle = "Amazing Post Title";
// const postUrl = "https://example.com/posts/123";
// const [showPopup, setShowPopup] = useState(false);
// const handleShareClick = () => {
//   setShowPopup(true);
// };

// const handleClosePopup = () => {
//   setShowPopup(false);
// };

//   // useEffect(() => {
//   //   const data = history.location.state
//   //   console.log(data)
//   //   setData(data)
//   // }, [])



//   return (
//     <>
//       <div className="outer-changes">
//         <section className="blogd-section">
//           <div className="upper-wrapper">
//             {/* <Header /> */}
//             <NewHeader />
//             <div className="container header-pad">
//               <div className="row">
//                 <div className="col-xl-12">
//                   <h5 className="blogd-sec">
//                     {/* 06 Hangout Spots Near Mula Mutha River Pune */}
//                     {data.title}
//                   </h5>
//                   <div className="blogd-top">
//                     <img src="../../images/blog-icon.png" alt="" />

//                     <span>
//                       {/* Veronica Ben */}{data.username}
//                     </span>
//                     <div className="date-blogd">
//                       <span>
//                         {/* 22 Jan 2023 */}{data.updatedAt}
//                       </span>
//                     </div>
//                   </div>
//                   <div className="blogd-btm-con pb-5">
//                     <p dangerouslySetInnerHTML={{
//                       __html: data.subtitle

//                       ,
//                     }}>
//                       {/* The Mula Mutha River is surrounded by the western ghats
//                       and Sahyadri mountain range in Pune. It caters to various
//                       kinds of activities for all types based on their interest
//                       levels. All kinds of camping, tracking, modern theme
//                       parks, dams, lakes, forts, beaches, waterfalls and
//                       different kinds of activities are here for you to enjoy
//                       with your friends. Below is a compiled list of places out
//                       in Pune with your friends. */}
//                     </p>
//                   </div>

//                   {/* <div className="row blogd-para">
//                     <div className="col-md-8">
//                       <div>
//                         <h5>1. Osho Ashram, Pune</h5>
//                         <p>
//                           Highlighting the world’s biggest meditation hall, this
//                           place is well- known as a meditation resort. People
//                           from all parts of the world flock here in search of
//                           inner peace. Spanning over 32 acres, it has a guest
//                           house if you want to stay on campus, a spa, sauna, a
//                           jacuzzi, gym, and a tennis court. Various meditation
//                           courses such as Nadabrahma, Nataraj, Kundalini, etc.
//                           are offered here for different rates.
//                         </p>
//                       </div>
//                     </div>
//                     <div className="col-md-4">
//                       <img src="../../images/osho.png" alt="" />
//                     </div>
//                     <div className="col-md-8">
//                       <div>
//                         <h5>2. Rajiv Gandhi Zoological Park, Pune</h5>
//                         <p>
//                           Divided into three parts – snake park, zoo and animal
//                           orphanage, this zoological park is a house to various
//                           species of mammals, reptiles, and birds. This is an
//                           amazing place to learn more about various animals as
//                           it provides detailed information on all the species
//                           that it is home to.
//                         </p>
//                       </div>
//                     </div>
//                     <div className="col-md-4">
//                       <img src="../../images/zoo.png" alt="" />
//                     </div>
//                     <div className="col-md-8">
//                       <div>
//                         <h5>3. Raja Dinkar Kelkar Museum, Pune</h5>
//                         <p>
//                           With over 20,000 artefacts, this place stands tall as
//                           one of the most artistic museums in the country. It is
//                           a must-visit for art lovers to experience the rich
//                           taste of the emperors &amp; artists who once lived in
//                           the region.
//                         </p>
//                       </div>
//                     </div>
//                     <div className="col-md-4">
//                       <img src="../../images/museum.png" alt="" />
//                     </div>
//                     <div className="col-md-8">
//                       <div>
//                         <h5> 4. Bund Garden, Pune</h5>
//                         <p>
//                           With over 20,000 artefacts, this place stands tall as
//                           one of the most artistic museums in the country. It is
//                           a must-visit for art lovers to experience the rich
//                           taste of the emperors &amp; artists who once lived in
//                           the region.
//                         </p>
//                       </div>
//                     </div>
//                     <div className="col-md-4">
//                       <img src="../../images/garden.png" alt="" />
//                     </div>

//                     <div className="col-md-8">
//                       <div>
//                         <h5> 5. Shaniwar Wada, Pune</h5>
//                         <p>
//                           The love story of Bajirao and Kashi began here and so
//                           did the unfinished love story of Bajirao-Mastani. The
//                           palace has been widely acclaimed for its ancient
//                           architecture. To showcase the rich history of ancient
//                           India, light and sound shows are organised here in the
//                           evenings every day.
//                         </p>
//                       </div>
//                     </div>
//                     <div className="col-md-4">
//                       <img src="../../images/wada-1.png" alt="" />
//                     </div>

//                     <div className="col-md-8">
//                       <div>
//                         <h5> 6. Vetal Tekdi, Pune</h5>
//                         <p>
//                           With an elevation of 2600 feet above sea level, Vetal
//                           Hill is the highest point in Pune. This is one of the
//                           best hangout places in Pune for friends to enjoy each
//                           other’s company and spend quality time capturing
//                           panoramic views of the city.
//                         </p>
//                       </div>
//                     </div>
//                     <div className="col-md-4">
//                       <img src="../../images/museum.png" alt="" />
//                     </div>
//                   </div> */}
//                 </div>
//                 {/* <div className="pb-3 blogd-para">
//                   <p>
//                     The weather in Pune is usually rewarding for the early
//                     risers. If you start your day early, there are abundant
//                     places that you can explore. However, to cover all the best
//                     places to visit in Pune with friends, you might need quite a
//                     few days or weekends.
//                   </p>
//                 </div> */}
//               </div>
//               <div className="lowerLine-1"></div>
//               <div className="blogd-comments">
//                 {/* <span  onClick={(e) => {
//                             addLike(detailsList, e);
//                           }}>
//                   <svg
//                     width="21"
//                     height="19"
//                     viewBox="0 0 21 19"
//                     fill="none"
//                     xmlns="http://www.w3.org/2000/svg"
//                   >
//                     <path
//                       d="M0.36377 17.8672C0.36377 18.2317 0.659211 18.5271 1.02374 18.5271H4.98358C5.61812 18.5271 6.18356 18.2267 6.5462 17.761C8.15489 18.2692 9.82476 18.5271 11.5139 18.5271H16.8631C17.9548 18.5271 18.843 17.6389 18.843 16.5472C18.843 16.2896 18.793 16.0435 18.7031 15.8175C19.5432 15.5885 20.163 14.8191 20.163 13.9073C20.163 13.4007 19.9713 12.938 19.6572 12.5874C19.9715 12.2368 20.163 11.7741 20.163 11.2674C20.163 10.7608 19.9713 10.2981 19.6572 9.9475C19.9715 9.59689 20.163 9.13422 20.163 8.62755C20.163 7.53585 19.2747 6.64763 18.183 6.64763H14.5705C14.6218 6.52629 14.6747 6.40324 14.7287 6.27812C15.1291 5.34951 15.5431 4.38929 15.5431 3.34777C15.5431 1.52356 14.0677 0.00390625 12.2433 0.00390625C11.9288 0.00390625 11.6579 0.22596 11.5962 0.534463L11.2592 2.21963C10.8164 4.43294 10.3275 4.68353 8.50825 5.61574C8.02736 5.86202 7.46243 6.15162 6.80315 6.5275C6.49963 5.82267 5.79841 5.32769 4.98358 5.32769H1.02374C0.659211 5.32769 0.36377 5.62313 0.36377 5.98766V17.8672ZM9.10996 6.79046C10.0951 6.28568 10.8066 5.92115 11.3638 5.30397C11.9336 4.6727 12.2783 3.85409 12.5535 2.47846L12.7692 1.39947C13.5969 1.64181 14.2232 2.43601 14.2232 3.34777C14.2232 4.11671 13.864 4.94975 13.5165 5.75547C13.3905 6.04781 13.2619 6.34669 13.1475 6.64763H12.2433C11.8788 6.64763 11.5833 6.94307 11.5833 7.30761C11.5833 7.67214 11.8788 7.96758 12.2433 7.96758H18.183C18.5469 7.96758 18.843 8.26371 18.843 8.62755C18.843 8.9914 18.5469 9.28753 18.183 9.28753H16.8631C16.4986 9.28753 16.2031 9.58297 16.2031 9.9475C16.2031 10.312 16.4986 10.6075 16.8631 10.6075H18.183C18.5469 10.6075 18.843 10.9036 18.843 11.2674C18.843 11.6313 18.5469 11.9274 18.183 11.9274H16.8631C16.4986 11.9274 16.2031 12.2229 16.2031 12.5874C16.2031 12.9519 16.4986 13.2474 16.8631 13.2474H18.183C18.5469 13.2474 18.843 13.5435 18.843 13.9073C18.843 14.2712 18.5469 14.5673 18.183 14.5673H16.8631C16.4986 14.5673 16.2031 14.8627 16.2031 15.2273C16.2031 15.5918 16.4986 15.8873 16.8631 15.8873C17.2269 15.8873 17.5231 16.1834 17.5231 16.5472C17.5231 16.9111 17.2269 17.2072 16.8631 17.2072H11.5139C9.96689 17.2072 8.43744 16.9721 6.9635 16.5087V7.96191C7.81442 7.45455 8.52612 7.08968 9.10996 6.79046ZM1.68372 6.64763H4.98358C5.34742 6.64763 5.64355 6.94376 5.64355 7.30761V16.5472C5.64355 16.9111 5.34742 17.2072 4.98358 17.2072H1.68372V6.64763Z"
//                       fill="#0A0A13"
//                     />
//                   </svg>
//                   <span>{data.line7
//                   }</span>
//                 </span> */}

//                 {isLikeshow && (
//                         <AiOutlineLike
//                           style={{ cursor: "pointer" }}
//                           size={25}
//                           onClick={(e) => {
//                             addLike(detailsList, e);
//                           }}
//                         ></AiOutlineLike>
//                       )}
//                       {!isLikeshow && (
//                         <AiTwotoneLike
//                           style={{ cursor: "pointer" }}
//                           color="blue"
//                           onClick={(e) => {
//                             deleteLike(detailsList, e);
//                             setlikewriteblogtopiclist(
//                               parseInt(likewriteblogtopiclist) - 1
//                             );
//                           }}
//                           size={25}
//                         ></AiTwotoneLike>
//                       )}

//                 <span onClick={(e) => AddComment(detailsList, e)}>
//                   <svg
//                     width="21"
//                     height="19"
//                     viewBox="0 0 40 41"
//                     fill="none"
//                     xmlns="http://www.w3.org/2000/svg"
//                   >
//                     <path
//                       d="M33.5749 3.06763H6.38603C3.54332 3.06763 1.23047 5.38002 1.23047 8.22319V24.8622C1.23047 27.699 3.53325 30.0077 6.36772 30.0178V37.5684L17.2188 30.0178H33.5749C36.4176 30.0178 38.7305 27.7049 38.7305 24.8622V8.22319C38.7305 5.38002 36.4176 3.06763 33.5749 3.06763ZM36.5332 24.8622C36.5332 26.4932 35.2061 27.8205 33.5749 27.8205H16.5294L8.56499 33.3627V27.8205H6.38603C4.75479 27.8205 3.42773 26.4932 3.42773 24.8622V8.22319C3.42773 6.59172 4.75479 5.26489 6.38603 5.26489H33.5749C35.2061 5.26489 36.5332 6.59172 36.5332 8.22319V24.8622Z"
//                       fill="#000"
//                     />
//                     <path
//                       d="M11.2671 10.8315H28.6937V13.0288H11.2671V10.8315Z"
//                       fill="#000"
//                     />
//                     <path
//                       d="M11.2671 15.519H28.6937V17.7163H11.2671V15.519Z"
//                       fill="#000"
//                     />
//                     <path
//                       d="M11.2671 20.2065H28.6937V22.4038H11.2671V20.2065Z"
//                       fill="#000"
//                     />
//                   </svg>
//                   <span>{data.line8} </span>
//                 </span>



//                 {/* <span>{data.line8} Comments</span> */}
//                 <span data-bs-toggle="modal"
//                         data-bs-target="#exampleModal">
//                   <svg
//                     width="21"
//                     height="19"
//                     viewBox="0 0 40 41"
//                     fill="none"
//                     xmlns="http://www.w3.org/2000/svg"
//                   >
//                     <path
//                       fill-rule="evenodd"
//                       clip-rule="evenodd"
//                       d="M0 40.3722L2.97793 33.5138C6.46609 26.5697 13.4734 21.995 21.1829 21.5713V31.0365L40 15.6811L21.1829 0.372192V9.85623C9.41977 10.4699 0 20.2607 0 32.1593V40.3722ZM2.49341 29.7258C3.70414 19.8655 12.1713 12.1684 22.3554 12.1684H23.5279V5.3012L36.2898 15.6838L23.5279 26.098V19.1965H22.3554C14.3665 19.1965 6.9241 23.2296 2.49341 29.7258Z"
//                       fill="#000"
//                     />
//                   </svg>
//                   <span data-bs-toggle="modal"
//                         data-bs-target="#exampleModal">{data.line9} </span>
//                 </span>

//                 <div
//                     class="modal fade"
//                     style={{ opacity: "1", marginTop: "32rem" }}
//                     id="exampleModal"
//                     tabindex="-1"
//                     aria-labelledby="exampleModalLabel"
//                     aria-hidden="true"
//                   >
//                     <div class="modal-dialog">
//                       <div class="modal-content">
//                         <div class="modal-header">
//                           <h5 class="modal-title" id="exampleModalLabel">
//                             Share Via
//                           </h5>
//                           <button
//                             type="button"
//                             class="btn-close"
//                             data-bs-dismiss="modal"
//                             aria-label="Close"
//                           ></button>
//                         </div>
//                         <div class="modal-body">
//                           <FacebookShareButton url={shareUrl}>
//                             <FacebookIcon size={40} round />
//                           </FacebookShareButton>
//                           <TwitterShareButton className="mx-3" url={shareUrl}>
//                             <TwitterIcon size={40} round />
//                           </TwitterShareButton>
//                           <LinkedinShareButton url={shareUrl}>
//                             <LinkedinIcon size={40} round />
//                           </LinkedinShareButton>
//                           <WhatsappShareButton className="mx-3" url={shareUrl}>
//                             <WhatsappIcon size={40} round />
//                           </WhatsappShareButton>
//                           <EmailShareButton url={shareUrl}>
//                             <EmailIcon size={40} round />
//                           </EmailShareButton>
//                           <TelegramShareButton className="mx-3" url={shareUrl}>
//                             <TelegramIcon size={40} round />
//                           </TelegramShareButton>
//                         </div>
//                         {/* <div class="modal-footer">
//         <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
//         <button type="button" class="btn btn-primary">Save changes</button>
//       </div> */}
//                       </div>
//                     </div>
//                   </div>


//                 {/* <span>{data.line9} Shares</span> */}
//               </div>
//               {isshowcomment && (
//                     <div className="commentStart first-cmt">
//                       <form 
//                       onSubmit={handleSubmit}
//                       >
//                         <div className="row">
//                           <div className="col-xl-11">
//                             <div className="form-group">
//                               <label
//                                 className="first-cmt1"
//                                 style={{ display: "block", fontSize: "20px" }}
//                               >
//                                 Comment
//                               </label>
//                               <textarea
//                                 className="fb-textarea"
//                                 required
//                                 onChange={(e) => setcomment(e.target.value)}
//                                 id="comment"
//                                 name="comment"
//                               >
//                                 {" "}
//                               </textarea>
//                               {/* <input
//                                   className="form-control"
//                                   type="text"
//                                   name="comment"
//                                   id="comment"
//                                   placeholder=""
//                                   required
//                                   onChange={(e) => setcomment(e.target.value)} 
//                                 /> */}
//                             </div>
//                           </div>
//                           <div className="col-xl-1">
//                             <div className="Btp-button btp-btn-new">
//                               <button
//                                 className="Btp-btn2 textarea-btn1 me-5"
//                                 type="submit"
//                                 style={{ padding: "4px 6px !important" }}
//                               >
//                                 Post
//                               </button>

//                               <button
//                                 className="Btp-btn textarea-btn"
//                                 onClick={() => setisshowcomment(false)}
//                               >
//                                 Cancel
//                               </button>
//                             </div>
//                           </div>
//                         </div>
//                       </form>
//                     </div>
//                   )}

//                   {/* {Commentlist.slice(0, commentsToShow).map((item, index) => {
//                     return ( */}
//                       <div 
//                       // key={item.id}
//                       >
//                         <div className="commentStart">
//                           <img src="../../images/profile4.png"></img>
//                           &nbsp;&nbsp;
//                           <div className="comment1P">
//                             <div className="comment1">
//                               {" "}
//                               <h6 className="Forumname1">Excellent</h6>
//                               <span className="commentTime">
//                               {/* {day}/{month}/{year}&nbsp;&nbsp;{h}:{m} */}
//                               10-10-25

//                                 {/* 8h &nbsp;
//                                   <FiberManualRecordIcon className="dotIcon" />
//                                   <FiberManualRecordIcon className="dotIcon" />
//                                   <FiberManualRecordIcon className="dotIcon" /> */}
//                               </span>
//                             </div>
//                             <div>
//                               <p className="comment1fourm">hii</p>
//                             </div>
//                             <div className="commentLike">
//                               <span className="commentLikeT">
//                                 Like &nbsp;
//                                 {/* {item?.likelist.length == 0 && ( */}
//                                   <AiOutlineLike
//                                     size={20}
//                                     // onClick={(e) => updatecommentLike(item, e)}
//                                   ></AiOutlineLike>
//                                  {/* )}  */}
//                               </span>
//                               {/* {item?.likelist.map((u, i) => {
//                                 return ( */}
//                                   <span className="commentLikeT" 
//                                   // key={u.id}
//                                   >
//                                     {/* {JSON.parse(sessionStorage.getItem("items"))
//                                       ._id == u.userID && ( */}
//                                       <AiTwotoneLike
//                                         color="blue"
//                                         // onClick={(e) =>
//                                         //   deletecommentLike(item, u, e)
//                                         // }
//                                         size={20}
//                                       ></AiTwotoneLike>
//                                      {/* )}  */}
//                                   </span>
//                                  {/* ); */}
//                               {/* })}  */}
//                               <span className="commentLikeT">
//                                 {0}
//                               </span>
//                               <span className="commentReplay">
//                                 {" "}
//                                 <AiOutlineComment
//                                   size={20}
//                                   onClick={(e) => insertcommentReply('item.id')}
//                                 ></AiOutlineComment>{" "}
//                                 Reply{" "}
//                               </span>
//                             </div>
//                             {/* {isshowcommentReply  && ( */}
//                               <div className="commentStart">
//                                 <form>
//                                   <div className="row">
//                                     <div className="col-xl-12">
//                                       <div className="form-group">
//                                         <label>Add Reply</label>

//                                         <input
//                                           className="form-control"
//                                           type="text"
//                                           name="reply"
//                                           id="reply"
//                                           placeholder=""
//                                           required
//                                           onChange={(e) =>
//                                             setreply(e.target.value)
//                                           }
//                                         />
//                                       </div>
//                                     </div>
//                                   </div>
//                                   <div className="Btp-button ">
//                                     <button
//                                       className="Btp-btn2"
//                                       type="button"
//                                       onClick={(e) => SubmitReply()}
//                                     >
//                                       post
//                                     </button>
//                                   </div>
//                                 </form>
//                               </div>
//                             {/* )} */}
//                           </div>
//                         </div>
//                         {/* {item?.replylist.map((u, i) => {
//                           return ( */}
//                             <div className="commentStart commentStart2">
//                               <img src="../../images/Ellipse 9.png"></img>
//                               &nbsp;&nbsp;
//                               <div className="comment1P">
//                                 <div className="comment1">
//                                   {" "}
//                                   <h6 className="Forumname1">responder</h6>
//                                   <span className="commentTime">
//                                    19/10/2023&nbsp;&nbsp;13:55
//                                     {/* <FiberManualRecordIcon className="dotIcon" />
//                                     <FiberManualRecordIcon className="dotIcon" />
//                                     <FiberManualRecordIcon className="dotIcon" /> */}
//                                   </span>
//                                 </div>
//                                 <div>
//                                   <p className="comment1fourm">Yes It Is !!</p>
//                                 </div>
//                                 <div className="commentLike">
//                                   <span className="commentLikeT">
//                                     Like &nbsp;
//                                     <img src="../../images/Like&N.png"></img>
//                                   </span>
//                                   <span className="commentReplay">Reply 1</span>
//                                 </div>
//                               </div>
//                             </div>
//                            {/* );
//                         })}  */}
//                       </div>
//                      {/* );
//                   })}  */}
//                   {commentsToShow < Commentlist.length && (
//                     <button
//                       onClick={() => setCommentsToShow(commentsToShow + 4)}
//                       className="view-more-btn-fb"
//                     >
//                       View More
//                     </button>
//                   )}


//               {/* <div className="lowerLine-1"></div> */}
//             </div>
//           </div>
//         </section>
//       </div>
//       <Footer />
//     </>
//   );
// };
// export default BlogD;

import React, { useState } from "react";
import "../../English/forumblogs/forumblog.css";
import Header from "../header/header";
import Footer from "../footer/footer";
import { Link } from "react-router-dom";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import NewHeader from "../NewHeader/NewHeader";
import { useHistory } from "react-router-dom";
import ServiceStore from "../../utils/ServiceStore";
import imgeurl from "../../utils/constant";
import {
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  LinkedinShareButton,
  WhatsappShareButton,
  EmailShareButton,
  TelegramShareButton,
  TwitterIcon,
  LinkedinIcon,
  WhatsappIcon,
  EmailIcon,
  TelegramIcon,
} from "react-share";

import {
  AiOutlineLike,
  AiTwotoneLike,
  AiOutlineComment,
  AiOutlineWechat,
} from "react-icons/ai";
import { red } from "@mui/material/colors";

const BlogD = () => {
  const history = useHistory();
  const [detailsList, setDetailsList] = React.useState({});
  const [isLikeshow, setisLikeshow] = React.useState(true);
  const [iserror, setiserror] = React.useState("");
  const [comment, setcomment] = React.useState("");
  const [likeCount, setLikeCount] = React.useState(477);

  const [likecommentwriteblogtopic, setlikecommentwriteblogtopic] =
    React.useState([]);

  const [LikeList, setLikeList] = React.useState({});
  const [likewriteblogtopiclist, setlikewriteblogtopiclist] = React.useState(1);
  const [isshowcomment, setisshowcomment] = React.useState(false);
  const [Commentlist, setCommentlist] = React.useState([]);
  const [iscommentLikeshow, setiscommentLikeshow] = React.useState(undefined);
  const [isshowcommentReply, setisshowcommentReply] = React.useState(undefined);
  const [reply, setreply] = React.useState("");
  const [newDate, setNewDate] = React.useState("");
  const insertcommentReply = (id) => setisshowcommentReply(id);
  const [commentsToShow, setCommentsToShow] = useState(4);
  const [relatedData, setRelatedData] = useState([]);
  const [saveContentIcon, setSaveContentIcon] = useState()
  const [isfav, setisfav] = useState("");

  React.useEffect(() => {
    if (JSON.parse(sessionStorage.getItem("items"))) {
      
      const dataid = history.location.state?.id || history.location.state?._id
      const hisData = history.location.state;
      getcommentwriteblogtopic();
      if (dataid) {
        getLikelist();

        new ServiceStore()
          .GetDataByID("writeblogtopic/", dataid)
          .then((res) => {
            const dates = res.data.updatedAt;
            setNewDate(
              res.data.updatedAt.split("T")[0].split("-").reverse().join("/")
            );
            console.log(res.data)
            setDetailsList(res.data);
            if (res.data) {
              AlreadySaveOrNot();
            }
          });
        // new ServiceStore().GetAllData('likewriteblogtopic/English').then((res) => {
        //   setlikewriteblogtopiclist(res.data)
        // });
        const auth = sessionStorage.getItem("items");
        if (auth) {
          const data = {
            writeblogtopicId: dataid,
            userID: JSON.parse(auth)._id,
          };
          new ServiceStore()
            .GetDataBYFilter("likewriteblogtopic/EnglishListByID", data)
            .then((res) => {
              if (res.response.data.length == 1) {
                setisLikeshow(false);
              }
              setLikeList(res.response.data);
            });
        }
      }

      new ServiceStore().GetAllData("writeblogtopic/English").then((res) => {
        const array = [];
        res.data.filter((data) => {
          if (data.categoryId === hisData.categoryId) {
            data.createdAt = data.createdAt
              .split("T")[0]
              .split("-")
              .reverse()
              .join("/");
            array.push(data);
          }
        });
        setRelatedData(array);
      });
    }
    else {
      alert("Please log in or sign in")
      history.push("/English/Blog")
    }
  }, [saveContentIcon]);
  const date = new Date();
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  const shareUrl = window.location.href;
  const h = date.getHours();
  const m = date.getMinutes();

  const getLikelist = () => {
    const dataid = history.location.state?.id;
    new ServiceStore()
      .GetDataByID("likewriteblogtopic/English/", dataid)
      .then((res) => {
        setlikewriteblogtopiclist(res.data ? res.data : 0);
      });
  };
  const addLike = (index, e) => {
    setlikewriteblogtopiclist(
      (likewriteblogtopiclist ? parseInt(likewriteblogtopiclist) : 1) + 1
    );
    const auth = sessionStorage.getItem("items");
    if (auth) {
      const methods = "likewriteblogtopic/";
      const data = {
        language: "english",
        username: JSON.parse(auth).name,
        count: 1,
        writeblogtopicId: detailsList.id,
        like: 1,
        status: "IsLike",
        userID: JSON.parse(auth)._id,
      };
      new ServiceStore().InsertData(methods, data).then((res) => {
        setisLikeshow(false);
        getLikelist();
      });
    } else {
      setiserror("Please Log in First");
    }
  };

  const AlreadySaveOrNot = () => {
    const auth = sessionStorage.getItem("items");
    const dataid = history.location.state?.id || history.location.state?._id
    if (auth) {
      const methods = "user/favourite/statuscheck";
      const data = {
        userId: JSON.parse(auth)._id,
        id: dataid,
        type: "blog"
      };
      new ServiceStore().InsertData(methods, data).then((res) => {
        //  console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>", res)
        // console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>", res.response.data.isFav)
        // if(res.response.data.status === 1)
        if (res.response.data.isFav === "False") {
          setSaveContentIcon(false)
        }
        else if (res.response.data.isFav === "True") {
          // console.log(">>>>>>>>>>>>>>>>>>>true")
          setSaveContentIcon(true)
        }
        else {
          setSaveContentIcon(false)

        }
      });
    } else {
      setiserror("Please Log in First");
    }
  }

  const saveData = () => {
    const auth = sessionStorage.getItem("items");
    if (auth) {
      const methods = "user/favourite/add";
      const data = {
        userId: JSON.parse(auth)._id,
        id: detailsList.id,
        type: "blog"
      };
      new ServiceStore().UpdateData(methods, data).then((res) => {
        console.log(res)
      });
      setSaveContentIcon(true)
    } else {
      setiserror("Please Log in First");
    }
  }

  const unsaveData = () => {
    const auth = sessionStorage.getItem("items");
    if (auth) {
      const methods = "user/favourite/remove";
      const data = {
        userId: JSON.parse(auth)._id,
        id: detailsList.id,
        type: "blog"
      };
      new ServiceStore().UpdateData(methods, data).then((res) => {
        console.log("remove:::::::::::::::::",res)
      });
      setSaveContentIcon(false)
    } else {
      setiserror("Please Log in First");
    }
  }

  const AddComment = (index, e) => {
    setisshowcomment(true);
  };

  const deleteLike = (index, e) => {
    const auth = sessionStorage.getItem("items");
    if (auth) {
      const methods = "likewriteblogtopic/deletelike";
      const data = {
        writeblogtopicId: detailsList.id,
        userID: JSON.parse(auth)._id,
      };
      new ServiceStore().InsertData(methods, data).then((res) => {
        setisLikeshow(true);
        getLikelist();
      });
    } else {
      setiserror("Please Log in First");
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (comment != undefined) {
      const auth = JSON.parse(sessionStorage.getItem("items"));
      const methods = "commentwriteblogtopic/";
      const data = {
        likecount: 0,
        language: "english",
        username: auth.name,
        comment: comment,
        writeblogtopicId: detailsList.id,
        status: "IsComment",
        userID: auth._id,
      };
      console.log("datalist :", detailsList)
      console.log("data :", data)
      new ServiceStore().InsertData(methods, data).then((res) => {
        getcommentwriteblogtopic();
      });
    }
    setisshowcomment(false);
  };

  const getcommentwriteblogtopic = () => {
    const dataid = history.location.state?.id;
    const auth = JSON.parse(sessionStorage.getItem("items"));
    console.log("data :", auth)
    const data = { writeblogtopicId: dataid, userID: auth._id };
    new ServiceStore()
      .GetDataBYFilter("commentwriteblogtopic/EnglishListByID", data)
      .then((res) => {
        console.log(res);
        res.response.data.filter((data) => {
          const d = data.createdAt.split("T")[0].split("-").reverse().join("/");
          const t = data.createdAt
            .split("T")[1]
            .split("-")
            .reverse()
            .join("/")
            .split(":");
          const full = d + " " + t[0].concat(":", t[1]);

          data.createdAt = full;
        });
        setCommentlist(res.response.data);
      });
  };

  const updatecommentLike = (index, e) => {
    const auth = JSON.parse(sessionStorage.getItem("items"));
    if (auth) {
      const methods = "likecommentwriteblogtopic";
      const data = {
        likecount: 1,
        language: "english",
        username: auth.name,
        writeblogtopicId: index.writeblogtopicId,
        status: "IsLike",
        userID: auth._id,
        commentId: index.id,
      };
      new ServiceStore().InsertData(methods, data).then((res) => {
        getcommentwriteblogtopic();
      });
    } else {
      setiserror("Please Log in First");
    }
  };
  const deletecommentLike = (index, u, e) => {
    const auth = sessionStorage.getItem("items");
    const likecount = Number(index.likecount) - 1;
    if (auth) {
      const methods = "likecommentwriteblogtopic/";

      new ServiceStore().DeleteData(methods, u._id).then((res) => {
        getcommentwriteblogtopic();
      });
    } else {
      setiserror("Please Log in First");
    }
  };

  const SubmitReply = (item, e) => {
    e.preventDefault();
    const auth = JSON.parse(sessionStorage.getItem("items"));
    if (reply != "") {
      const methods = "replaycommentwriteblogtopic/";
      const data = {
        likecount: 0,
        language: "english",
        username: auth.name,
        reply: reply,
        writeblogtopicId: item.writeblogtopicId,
        status: "IsReply",
        userID: auth._id,
        commentId: item.id,
      };
      new ServiceStore().InsertData(methods, data).then((res) => {
        getcommentwriteblogtopic();
        setisshowcommentReply(undefined);
        // history.push("/English/Forum");
      });
    }
  };

  const postTitle = "Amazing Post Title";
  const postUrl = "https://example.com/posts/123";
  const [showPopup, setShowPopup] = useState(false);
  const handleShareClick = () => {
    setShowPopup(true);
  };

  const handleClosePopup = () => {
    setShowPopup(false);
  };
  return (
    <>
      <div className="outer-changes">
        <section className="facility-section">
          <div className="upper-wrapper">
            {/* <Header /> */}
            <NewHeader />
            <div className="row header-pad" style={{ justifyContent: 'center' }}>
              <div className="col-xl-9">
                <div className="left-side-details" style={{ background: 'none' }}>

                  <div className="headings2">
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <div>
                        <h4>{detailsList?.title}</h4><br></br><br></br><br></br><br></br>
                      </div>
                      <div style={{display:'flex'}}>
                        <h5>
                          Add to Favourite
                        </h5>
                        <div>
                          {(saveContentIcon) ? <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="25" height="25" viewBox="0 0 50 50" onClick={(e) => {
                            unsaveData(detailsList, e);

                          }}>
                            <path d="M 37 48 C 36.824219 48 36.652344 47.953125 36.496094 47.863281 L 25 41.15625 L 13.503906 47.863281 C 13.195313 48.042969 12.8125 48.046875 12.503906 47.867188 C 12.191406 47.6875 12 47.359375 12 47 L 12 3 C 12 2.449219 12.449219 2 13 2 L 37 2 C 37.554688 2 38 2.449219 38 3 L 38 47 C 38 47.359375 37.808594 47.6875 37.496094 47.867188 C 37.34375 47.957031 37.171875 48 37 48 Z"></path>
                          </svg>
                            : <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="25" height="25" viewBox="0 0 50 50"
                              onClick={(e) => {
                                saveData(detailsList, e);
                              }}
                            >
                              <path d="M 12.8125 2 C 12.335938 2.089844 11.992188 2.511719 12 3 L 12 47 C 11.996094 47.359375 12.1875 47.691406 12.496094 47.871094 C 12.804688 48.054688 13.1875 48.054688 13.5 47.875 L 25 41.15625 L 36.5 47.875 C 36.8125 48.054688 37.195313 48.054688 37.503906 47.871094 C 37.8125 47.691406 38.003906 47.359375 38 47 L 38 3 C 38 2.449219 37.550781 2 37 2 L 13 2 C 12.96875 2 12.9375 2 12.90625 2 C 12.875 2 12.84375 2 12.8125 2 Z M 14 4 L 36 4 L 36 45.25 L 25.5 39.125 C 25.191406 38.945313 24.808594 38.945313 24.5 39.125 L 14 45.25 Z"></path>
                            </svg>}
                        </div>
                      </div>
                    </div>
                    <div className="left-side-info">
                      <div className="blogd-top2" style={{ display: 'contents' }}>
                        <div style={{ display: 'flex' }}>
                          <div>
                            <img src="../../images/profile4.png" alt="" />
                          </div>
                          <div><span>{detailsList.username}</span></div>
                        </div>
                        {/* <div>    */}
                        <div className="date-check">
                          {newDate ? newDate : ""}
                          {/* </div> */}
                        </div>
                      </div>
                    </div>
                    <br></br><br></br><br></br><br></br>
                    <p>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: detailsList?.subtitle,
                        }}
                      ></div>
                    </p>
                  </div>
                  <div className="top-a-class" style={{ display: 'none' }}>
                    <span>Category</span>
                    <a href="" className="margin-span">
                      {detailsList.categoryname
                        ? detailsList.categoryname
                        : "Unknown"}
                    </a>
                  </div>
                  <div className="blogd-comments" style={{ display: 'none' }}>
                    <span>
                      <svg
                        width="19"
                        height="19"
                        viewBox="0 0 19 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clipPath="url(#clip0_702_1990)">
                          <path
                            d="M9.5 19C14.7467 19 19 14.7467 19 9.5C19 4.25329 14.7467 0 9.5 0C4.25329 0 0 4.25329 0 9.5C0 14.7467 4.25329 19 9.5 19Z"
                            fill="url(#paint0_linear_702_1990)"
                          />
                          <path
                            d="M10.9158 5.04888L11.1904 3.51969C11.3356 2.71119 10.8384 1.92596 10.0455 1.71148L9.80909 1.64751C9.57371 1.58386 9.32539 1.68968 9.20832 1.90359L6.42208 6.99411C6.32951 7.16326 6.15196 7.2685 5.95911 7.2685H4.39399C4.1025 7.2685 3.86621 7.50479 3.86621 7.79628V13.773C3.86621 14.02 4.03747 14.234 4.27846 14.288L8.55916 15.2484C8.59711 15.2569 8.63584 15.2612 8.67469 15.2612H13.5309C14.3383 15.2612 15.0164 14.6536 15.1047 13.8511L15.8118 7.42652C15.915 6.48913 15.181 5.66997 14.2379 5.66997H11.4353C11.1065 5.66997 10.8577 5.37251 10.9158 5.04888Z"
                            fill="url(#paint1_linear_702_1990)"
                          />
                          <path
                            d="M4.74984 14.7777H3.69428C3.40279 14.7777 3.1665 14.5414 3.1665 14.2499V6.86103C3.1665 6.56954 3.40279 6.33325 3.69428 6.33325H4.74984C5.04133 6.33325 5.27762 6.56954 5.27762 6.86103V14.2499C5.27762 14.5414 5.04133 14.7777 4.74984 14.7777Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <linearGradient
                            id="paint0_linear_702_1990"
                            x1="2.7825"
                            y1="16.2175"
                            x2="16.2175"
                            y2="2.7825"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#5558FF" />
                            <stop offset="1" stop-color="#00C0FF" />
                          </linearGradient>
                          <linearGradient
                            id="paint1_linear_702_1990"
                            x1="5.0697"
                            y1="15.1951"
                            x2="14.7444"
                            y2="5.5205"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#ADDCFF" />
                            <stop offset="1" stop-color="#EAF6FF" />
                          </linearGradient>
                          <clipPath id="clip0_702_1990">
                            <rect width="19" height="19" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                      <span>
                        {likewriteblogtopiclist
                          ? parseInt(likewriteblogtopiclist)
                          : 1}
                      </span>
                    </span>
                    <span className="span-comment">
                      {Commentlist.length} Comments
                    </span>
                    <span>85 Shares</span>
                  </div>
                  <div className="lowerLine-1"></div>
                  <div className="blogd-comments2" style={{ justifyContent: 'start' }}>
                    <span>
                      {isLikeshow && (
                        <AiOutlineLike
                          style={{ cursor: "pointer" }}
                          size={25}
                          onClick={(e) => {
                            addLike(detailsList, e);
                          }}
                        ></AiOutlineLike>
                      )}
                      {!isLikeshow && (
                        <AiTwotoneLike
                          style={{ cursor: "pointer" }}
                          color="blue"
                          onClick={(e) => {
                            deleteLike(detailsList, e);
                            setlikewriteblogtopiclist(
                              parseInt(likewriteblogtopiclist) - 1
                            );
                          }}
                          size={25}
                        ></AiTwotoneLike>
                      )}
                      <span>Like</span>
                    </span>
                    <span
                      style={{ cursor: "pointer" }}
                      onClick={(e) => AddComment(detailsList, e)}
                    >
                      <svg
                        width="18"
                        height="19"
                        viewBox="0 0 18 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1.8 1.1001L16.2 1.1001C17.1756 1.1001 18 1.9245 18 2.9001V12.8001C18 13.7757 17.1756 14.6001 16.2 14.6001H7.6326L4.722 17.802C4.6638 17.8656 4.5828 17.9001 4.5 17.9001C4.4637 17.9001 4.4271 17.8935 4.3917 17.88C4.2762 17.8353 4.2 17.724 4.2 17.6001V14.6001H1.8C0.8244 14.6001 0 13.7757 0 12.8001L0 2.9001C0 1.9245 0.8244 1.1001 1.8 1.1001Z"
                          fill="#0A0A13"
                        />
                      </svg>

                      <span onClick={(e) => AddComment(detailsList, e)}>
                        Comment
                      </span>
                    </span>
                    <span
                      className="share-forum-main"
                      style={{ cursor: "pointer" }}
                    >
                      <svg
                        width="18"
                        height="19"
                        viewBox="0 0 18 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clipPath="url(#clip0_702_2055)">
                          <path
                            d="M9.5332 4.76783C4.25256 5.04282 0.00585937 9.42586 0.00585937 14.7734L0.00585937 18.5L1.33916 15.3961C2.91606 12.2428 6.04472 10.2266 9.5332 10.0413V14.3064L17.9935 7.39063L9.5332 0.5V4.76783Z"
                            fill="#0A0A13"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_702_2055">
                            <rect
                              width="18"
                              height="18"
                              fill="white"
                              transform="translate(0 0.5)"
                            />
                          </clipPath>
                        </defs>
                      </svg>

                      <span
                        data-bs-toggle="modal"
                        data-bs-target="#exampleModal"
                      >
                        Share
                      </span>
                    </span>
                  </div>
                  <div className="lowerLine-1"></div>

                  <span
                    style={{
                      color: "red",
                      fontSize: "20px",
                      marginLeft: "40%",
                    }}
                  >
                    {iserror}
                  </span>

                  <div
                    class="modal fade"
                    style={{ opacity: "1", marginTop: "32rem" }}
                    id="exampleModal"
                    tabindex="-1"
                    aria-labelledby="exampleModalLabel"
                    aria-hidden="true"
                  >
                    <div class="modal-dialog">
                      <div class="modal-content">
                        <div class="modal-header">
                          <h5 class="modal-title" id="exampleModalLabel">
                            Share Via
                          </h5>
                          <button
                            type="button"
                            class="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                          ></button>
                        </div>
                        <div class="modal-body">
                          <FacebookShareButton url={shareUrl}>
                            <FacebookIcon size={40} round />
                          </FacebookShareButton>
                          <TwitterShareButton className="mx-3" url={shareUrl}>
                            <TwitterIcon size={40} round />
                          </TwitterShareButton>
                          <LinkedinShareButton url={shareUrl}>
                            <LinkedinIcon size={40} round />
                          </LinkedinShareButton>
                          <WhatsappShareButton className="mx-3" url={shareUrl}>
                            <WhatsappIcon size={40} round />
                          </WhatsappShareButton>
                          <EmailShareButton url={shareUrl}>
                            <EmailIcon size={40} round />
                          </EmailShareButton>
                          <TelegramShareButton className="mx-3" url={shareUrl}>
                            <TelegramIcon size={40} round />
                          </TelegramShareButton>
                        </div>
                        {/* <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary">Save changes</button>
      </div> */}
                      </div>
                    </div>
                  </div>

                  {isshowcomment && (
                    <div className="commentStart first-cmt">
                      <form onSubmit={handleSubmit}>
                        <div className="row">
                          <div className="col-xl-11">
                            <div className="form-group">
                              <label
                                className="first-cmt1"
                                style={{ display: "block", fontSize: "20px" }}
                              >
                                Comment
                              </label>
                              <textarea
                                className="fb-textarea"
                                required
                                onChange={(e) => setcomment(e.target.value)}
                                id="comment"
                                name="comment"
                              >
                                {" "}
                              </textarea>
                              {/* <input
                                  className="form-control"
                                  type="text"
                                  name="comment"
                                  id="comment"
                                  placeholder=""
                                  required
                                  onChange={(e) => setcomment(e.target.value)} 
                                /> */}
                            </div>
                          </div>
                          <div className="col-xl-1">
                            <div className="Btp-button btp-btn-new">
                              <button
                                className="Btp-btn2 textarea-btn1 me-5"
                                type="submit"
                                style={{ padding: "4px 6px !important" }}
                              >
                                Post
                              </button>

                              <button
                                className="Btp-btn textarea-btn"
                                onClick={() => setisshowcomment(false)}
                              >
                                Cancel
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  )}

                  {Commentlist.slice(0, commentsToShow).map((item, index) => {
                    return (
                      <div key={item.id}>
                        <div className="commentStart">
                          <img src="../../images/profile4.png"></img>
                          &nbsp;&nbsp;
                          <div className="comment1P">
                            <div className="comment1">
                              {" "}
                              <h6 className="Forumname1">{item.username} </h6>
                              <span className="commentTime">
                                {item.createdAt}

                                {/* 8h &nbsp;
                                  <FiberManualRecordIcon className="dotIcon" />
                                  <FiberManualRecordIcon className="dotIcon" />
                                  <FiberManualRecordIcon className="dotIcon" /> */}
                              </span>
                            </div>
                            <div>
                              <p className="comment1fourm">{item.comment}</p>
                            </div>
                            <div className="commentLike">
                              <span className="commentLikeT">
                                Like &nbsp;
                                {item?.likelist.length == 0 && (
                                  <AiOutlineLike
                                    size={20}
                                    onClick={(e) => updatecommentLike(item, e)}
                                  ></AiOutlineLike>
                                )}
                              </span>
                              {item?.likelist.map((u, i) => {
                                return (
                                  <span className="commentLikeT" key={u.id}>
                                    {JSON.parse(sessionStorage.getItem("items"))
                                      ._id == u.userID && (
                                        <AiTwotoneLike
                                          color="blue"
                                          onClick={(e) =>
                                            deletecommentLike(item, u, e)
                                          }
                                          size={20}
                                        ></AiTwotoneLike>
                                      )}
                                  </span>
                                );
                              })}
                              <span className="commentLikeT">
                                {item.likeBYcount}
                              </span>
                              <span className="commentReplay">
                                {" "}
                                <AiOutlineComment
                                  size={20}
                                  onClick={(e) => insertcommentReply(item.id)}
                                ></AiOutlineComment>{" "}
                                Reply{" "}
                              </span>
                            </div>
                            {isshowcommentReply == item.id && (
                              <div className="commentStart">
                                <form>
                                  <div className="row">
                                    <div className="col-xl-12">
                                      <div className="form-group">
                                        <label>Add Reply</label>

                                        <input
                                          className="form-control"
                                          type="text"
                                          name="reply"
                                          id="reply"
                                          placeholder=""
                                          required
                                          onChange={(e) =>
                                            setreply(e.target.value)
                                          }
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="Btp-button ">
                                    <button
                                      className="Btp-btn2"
                                      type="button"
                                      onClick={(e) => SubmitReply(item, e)}
                                    >
                                      post
                                    </button>
                                  </div>
                                </form>
                              </div>
                            )}
                          </div>
                        </div>
                        {item?.replylist.map((u, i) => {
                          return (
                            <div className="commentStart commentStart2">
                              <img src="../../images/Ellipse 9.png"></img>
                              &nbsp;&nbsp;
                              <div className="comment1P">
                                <div className="comment1">
                                  {" "}
                                  <h6 className="Forumname1">{u.username}</h6>
                                  <span className="commentTime">
                                    {day}/{month}/{year}&nbsp;&nbsp;{h}:{m}
                                    {/* <FiberManualRecordIcon className="dotIcon" />
                                    <FiberManualRecordIcon className="dotIcon" />
                                    <FiberManualRecordIcon className="dotIcon" /> */}
                                  </span>
                                </div>
                                <div>
                                  <p className="comment1fourm">{u.reply}</p>
                                </div>
                                {/* <div className="commentLike">
                                  <span className="commentLikeT">
                                    Like &nbsp;
                                    <img src="../../images/Like&N.png"></img>
                                  </span>
                                  <span className="commentReplay">Reply 1</span>
                                </div> */}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    );
                  })}
                  {commentsToShow < Commentlist.length && (
                    <button
                      onClick={() => setCommentsToShow(commentsToShow + 4)}
                      className="view-more-btn-fb"
                    >
                      View More
                    </button>
                  )}
                  {/* <div className="commentLoadM">
                   <Link to="#"> <p className="commentLoad">Load More Comments</p> </Link>
                  </div> */}
                </div>
              </div>

            </div>
          </div>
        </section>
        <Footer />
      </div>
    </>
  );
};

export default BlogD;

